import React from 'react';
import { ScannerMode } from '../../../lib/contracts';
import ScannerPanel from './ScannerPanel';

export interface InlineScannerProps {
  mode?: ScannerMode;
  onScan: (upc: string) => void;
  onCooldown?: (upc: string, reason: 'cooldown' | 'duplicate') => void;
  title?: string;
  subtitle?: string;
  beepEnabled?: boolean;
  cooldownMs?: number;
  bottomSheetContent?: React.ReactNode;
  className?: string;
  /** When true, show Start button instead of auto-starting the camera. */
  manualStart?: boolean;
  /** When false, hide ScannerPanel's manual UPC overlay (parent provides one). */
  showManualFallback?: boolean;
}

const InlineScanner: React.FC<InlineScannerProps> = ({
  mode = ScannerMode.CUSTOMER_RETURN_SCAN,
  onScan,
  onCooldown,
  title = 'Barcode Scanner',
  subtitle = 'Point camera at container barcode',
  beepEnabled = true,
  cooldownMs = 900,
  bottomSheetContent,
  className = '',
  manualStart = true,
  showManualFallback = true
}) => {
  return (
    <div
      className={`relative overflow-hidden rounded-2xl border border-white/10 bg-black aspect-[4/3] min-h-[260px] ${className}`}
    >
      <ScannerPanel
        mode={mode}
        onScan={onScan}
        onCooldown={onCooldown}
        title={title}
        subtitle={subtitle}
        beepEnabled={beepEnabled}
        cooldownMs={cooldownMs}
        bottomSheetContent={bottomSheetContent}
        autoExpandSheetOnScan={false}
        manualStart={manualStart}
        showManualFallback={showManualFallback}
        className="absolute inset-0 h-full w-full"
      />
    </div>
  );
};

export default InlineScanner;
